import {ACTION_TYPE} from './actions';
import {initialState} from './initialState';

export function reducer(state, action) {
  switch (action.type) {
    case ACTION_TYPE.PROCESS_REQUEST: {
      return { ...initialState };
    }

    case ACTION_TYPE.PROCESS_REQUEST_SUCCESS: {
      return {
        ...state,
        init: true,
        ...action.data,
      };
    }

    case ACTION_TYPE.PROCESS_SET_APPLIED: {
      return {
        ...state,
        isFormOpen: false,
        isApplyButtonDisabled: false,
        process: {
          ...state.process,
          ...action.data,
        },
      };
    }

    case ACTION_TYPE.PROCESS_APPLY_FORM_SHOW: {
      return { ...state, isFormOpen: true, isApplyButtonDisabled: true };
    }

    case ACTION_TYPE.PROCESS_APPLY_FORM_HIDE: {
      return { ...state, isFormOpen: false, isApplyButtonDisabled: false };
    }

    case ACTION_TYPE.APPLY_BUTTON_ENABLE: {
      return { ...state, isApplyButtonDisabled: false };
    }

    case ACTION_TYPE.APPLY_BUTTON_DISABLE: {
      return { ...state, isApplyButtonDisabled: true };
    }

    default:
      throw new Error();
  }
}
